/**
 * Product Image Slider - INFINITE CAROUSEL VERSION
 * True infinite carousel with consistent directional sliding
 */

class ProductSlider {
  constructor(container) {
    this.container = container;
    this.currentIndex = 0;
    this.totalSlides = 2;
    this.isTransitioning = false;
    
    this.init();
  }
  
  init() {
    this.container.classList.add('slider-active');
    this.createSliderTrack();
    this.createArrows();
    this.createDots();
    this.updateSlidePosition(false);
    this.addResizeHandler();
  }
  
  addResizeHandler() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.calculateSlideWidth();
        this.updateSlidePosition(false);
      }, 250);
    });
  }
  
  createSliderTrack() {
    const firstImage = this.container.querySelector('.product-item__bg');
    const secondImage = this.container.querySelector('.product-item__bg__under');
    
    if (!firstImage || !secondImage) return;
    
    this.track = document.createElement('div');
    this.track.className = 'slider-track';
    
    const firstClone = firstImage.cloneNode(true);
    const secondClone = secondImage.cloneNode(true);
    
    firstClone.classList.add('clone');
    secondClone.classList.add('clone');
    
    this.track.appendChild(secondClone);
    this.track.appendChild(firstImage);
    this.track.appendChild(secondImage);
    this.track.appendChild(firstClone);
    
    const productLink = this.container.querySelector('.product-link');
    if (productLink) {
      productLink.innerHTML = '';
      productLink.appendChild(this.track);
    }
    
    this.calculateSlideWidth();
    this.currentIndex = 1;
    
    this.track.addEventListener('transitionend', () => {
      this.handleTransitionEnd();
    });
  }
  
  calculateSlideWidth() {
    const containerWidth = this.container.getBoundingClientRect().width;
    this.slideWidth = Math.round(containerWidth);
  }
  
  updateSlidePosition(animate = true) {
    if (!this.track) return;
    
    const offset = -this.currentIndex * this.slideWidth;
    
    if (animate) {
      this.track.style.transition = 'transform 0.4s ease-in-out';
    } else {
      this.track.style.transition = 'none';
    }
    
    this.track.style.transform = `translateX(${offset}px)`;
    
    const actualSlide = this.currentIndex === 1 ? 0 : (this.currentIndex === 2 ? 1 : (this.currentIndex === 0 ? 1 : 0));
    this.updateDots(actualSlide);
  }
  
  handleTransitionEnd() {
    this.isTransitioning = false;
    
    if (this.currentIndex === 0) {
      this.currentIndex = 2;
      this.updateSlidePosition(false);
    } else if (this.currentIndex === 3) {
      this.currentIndex = 1;
      this.updateSlidePosition(false);
    }
  }
  
  createArrows() {
    this.prevArrow = document.createElement('button');
    this.prevArrow.className = 'slider-arrow prev';
    this.prevArrow.setAttribute('aria-label', 'Previous image');
    this.prevArrow.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </svg>
    `;
    this.prevArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.prev();
    });
    
    this.nextArrow = document.createElement('button');
    this.nextArrow.className = 'slider-arrow next';
    this.nextArrow.setAttribute('aria-label', 'Next image');
    this.nextArrow.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </svg>
    `;
    this.nextArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.next();
    });
    
    this.container.appendChild(this.prevArrow);
    this.container.appendChild(this.nextArrow);
  }
  
  createDots() {
    this.dotsContainer = document.createElement('div');
    this.dotsContainer.className = 'slider-dots';
    
    for (let i = 0; i < this.totalSlides; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dot';
      dot.setAttribute('aria-label', `Go to image ${i + 1}`);
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToSlide(i);
      });
      this.dotsContainer.appendChild(dot);
    }
    
    this.container.appendChild(this.dotsContainer);
  }
  
  updateDots(activeIndex) {
    const dots = this.dotsContainer.querySelectorAll('.slider-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeIndex);
    });
  }
  
  next() {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.currentIndex++;
    this.updateSlidePosition(true);
  }
  
  prev() {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.currentIndex--;
    this.updateSlidePosition(true);
  }
  
  goToSlide(index) {
    if (this.isTransitioning) return;
    
    const targetIndex = index + 1;
    
    if (targetIndex !== this.currentIndex) {
      this.isTransitioning = true;
      this.currentIndex = targetIndex;
      this.updateSlidePosition(true);
    }
  }
}

// Auto-initialize
function initProductSliders() {
  const sliderContainers = document.querySelectorAll('.product-item__image.double__image');
  
  sliderContainers.forEach(container => {
    if (!container.classList.contains('slider-active')) {
      new ProductSlider(container);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSliders);
} else {
  initProductSliders();
}

document.addEventListener('shopify:section:load', initProductSliders);
document.addEventListener('shopify:section:reorder', initProductSliders);

window.ProductSlider = ProductSlider;
window.initProductSliders = initProductSliders;